export const handleApiError = (error) => {
    let errorMessage = "An unexpected error occurred.";
    if (error.response) {
        errorMessage = error.response.data?.message || "Something went wrong.";
    } else if (error.request) {
        errorMessage = "No response from the server";
    } else {
        errorMessage = error.message || "Client-side error occurred.";
    }

    console.error("API Error:", errorMessage);
    return { success: false, message: errorMessage };
};
